import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { AppService } from '../../app.service';
import { LenderConfiguration } from '../../models/CommsPlatform/lender-configuration';
import { OnboardResult } from '../../models/CommsPlatform/onboard-result';
import { IdName } from '../../models/id-name';
import { ClientLenderConfigurationSearchRequest } from '../../models/CommsPlatform/client-lender-configuration-search-request';
import { ClientLenderConfigurationSearchResult } from '../../models/CommsPlatform/client-lender-configuration-search-result';
import { AddClientLenderConfigurationResult } from '../../models/CommsPlatform/add-client-lender-configuration-result';

@Injectable({
    providedIn: 'root',
})
export class CommsPlatformConfigService {
    private _baseUrl: string = '';
    private _token: string = '';

    public constructor(
        public appService: AppService,
        public http: HttpClient,
        @Inject('API_BASE_URL') baseurl: string
    ) {
        this._baseUrl = baseurl;

        const loggedUserSession = localStorage.getItem('userSession');
        if (loggedUserSession) {
            const loggedUserToken =
                JSON.parse(loggedUserSession).AuthenticatedUser.Token;
            this._token = loggedUserToken;
        }
    }

    public getIntegrationByCreditorId = (
        creditorId: number,
        integration: string
    ): Observable<any> => {
        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apiPath: string =
            'CommsPlatformConfig/read-' +
            integration +
            '?creditorId=' +
            creditorId;
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public getMobileNumbersById = (
        Id: number,
        integration: string
    ): Observable<any> => {
        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apiPath: string =
            'CommsPlatformConfig/read-' + integration + '?Id=' + Id;
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public createIntegration = (
        creditorId: number,
        integration: string,
        model: any
    ): Observable<any> => {
        const apiPath: string = 'CommsPlatformConfig/create-' + integration;
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();
        const params: any = {
            CreditorId: creditorId,
            ...model,
        };

        return this.http.post<any>(fullPath, params, options);
    };

    public createMobileNumber = (
        Id: number,
        integration: string,
        model: any
    ): Observable<any> => {
        const apiPath: string = 'CommsPlatformConfig/create-' + integration;
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();
        const params: any = {
            TelgorithmIntegrationId: Id,
            ...model,
        };

        return this.http.post<any>(fullPath, params, options);
    };

    public updateIntegration = (
        model: any,
        integration: string
    ): Observable<any> => {
        const apiPath: string = 'CommsPlatformConfig/update-' + integration;
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();
        const params: any = {
            ...model,
        };

        return this.http.put<any>(fullPath, params, options);
    };

    public deleteIntegration = (
        id: number,
        integration: string
    ): Observable<any> => {
        const apiPath: string =
            'CommsPlatformConfig/delete-' + integration + '?id=' + id;
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.delete<any>(fullPath, options);
    };

    public getAllClients = (): Observable<IdName[] | null> => {

        const apiPath: string = 'CommsPlatformConfig/get-all-clients';
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        var result = this.http.get(fullPath, options).pipe(map((r: any) => r as IdName[]));

        return result;
    }

    public searchCommsPlatformConfigurations = (searchRequest: ClientLenderConfigurationSearchRequest): Observable<ClientLenderConfigurationSearchResult[] | null> => {

        const apiPath: string = "CommsPlatformConfig/search-client-lender-configurations";
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        var result = this.http.post<ClientLenderConfigurationSearchRequest>(fullPath, searchRequest, options).pipe(map((r: any) => r as ClientLenderConfigurationSearchResult[]));

        return result;
    }

    public onBoardCommsPlatformLender = (request: LenderConfiguration): Observable<AddClientLenderConfigurationResult | null> => {

        const apiPath: string = 'CommsPlatformConfig/add-client-lender-configuration';
        const fullPath: string = this._baseUrl + apiPath;
        const options = this.appService.getHttpHeaderOptions();

        var result = this.http.post<any>(fullPath, request, options).pipe(map((r: any) => r as AddClientLenderConfigurationResult));

        return result;
    }
}
